import React from "react";
import { MARQUEE } from "../lib/data";

export const Marquee = () => {
  const items = [...MARQUEE, ...MARQUEE];
  return (
    <section data-testid="marquee" className="border-y border-line bg-surface py-6 overflow-hidden">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {items.map((t, i) => (
          <span key={i} className="flex items-center font-mono text-sm uppercase tracking-[0.25em] text-mute">
            <span className="px-8">{t}</span>
            <span className="text-brass">/</span>
          </span>
        ))}
      </div>
    </section>
  );
};
